import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import moment from "moment";
import { makeStyles } from "@mui/styles";
import Tooltip from "@mui/material/Tooltip";
import UserService from "services/UserService";
import styled from "styled-components";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import {
  getGEBMeteringPlans, getGEBMeteringPlan, getAlerts,
  getGEB2DPlans, getGEB2DPlan, downloadFile, getMBMDashboard, getChartpoints,
  deleteGEBMeteringPlan, deleteGEB2DPlan, getMBMIotdevices, getMBMEquipments, getMBMAVOBBoxs,
  deleteGEB2dPlanItem, postMBMPointData, getChart, getChartV2, putGEB2dPlanItem, deleteGEBMeteringPlanItem
} from "services/ConfigServices";
import { dashboardText } from "variables/MBM/geb";
import CustomSelect from "components/Input/CustomSelect.js";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardBody from "components/Card/CardBody";
import styles from "assets/jss/material-dashboard-pro-react/views/chartsStyle";
import { getChartCategoryScriptV2 } from "components/ChartV2/ChartV2";
import AcUnitIcon from '@mui/icons-material/AcUnit';
import ElectricMeterIcon from '@mui/icons-material/ElectricMeter';
import SpeedIcon from '@mui/icons-material/Speed';
import WifiIcon from '@mui/icons-material/Wifi';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import Button from "components/CustomButtons/Button.js";
import SpeakerPhoneIcon from '@mui/icons-material/SpeakerPhone';
import MeteringPlanTree from "./MeteringPlan/MeteringPlanTree";
import Columns from "./Charts/Columns";
import { Abc } from "components/CustomIcon/CustomIcon";
import MeteringPlanItemDialog from "./MeteringPlan/MeteringPlanItemDialog";
import Dialog from '@mui/material/Dialog';
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import { NotificationManager } from 'react-notifications';
import { withStyles } from "@mui/styles";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import ViewPointDataDialog from "./Plans/ViewPointDataDialog";
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MeteringPlanDialog from "./MeteringPlan/MeteringPlanDialog";
import SankeyDialog from "./MeteringPlan/SankeyDialog";
import Plan2dDialog from "./Plan2d/Plan2dDialog";
import Plan2dItemDialog from "./Plan2d/Plan2dItemDialog";
import { Plan2dIot, Plan2dEquipment, Plan2dData, Plan2dLink } from "./Plan2d/Plan2dFunctions";
import uuid from "react-uuid";
import { Plan2dSlider } from "./Plan2d/Plan2dSlider";
import { getChartCategoryScript } from "components/Charts/getChartCategoryScript";
import ViewIotDialog from "./Plan2d/ViewIotDialog";
import ViewEquipmentDialog from "./Plan2d/ViewEquipmentDialog";
import { definitionData as iotdefinitiondata } from "variables/MBM/lists/iotdevices";
import { definitionData as eqdefinitionData } from "variables/MBM/lists/equipments";
import { dico } from "variables/lists/dico";
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import RefreshIcon from '@mui/icons-material/Refresh';
import AutomationWidget from "./Automation/AutomationWidget";
// import { Menu, MenuItem } from "@mui/material";

const menuButtonStyle = {
  float: "right",
  position: "relative",
  marginRight: "0",
  paddingTop: "0",
  paddingBottom: "0px",
  paddingRight: "2px",
  paddingLeft: "2px",
  fontFamily: '"Source Sans Pro",sans-serif',
  color: "#000000",
  background: "transparent",
  boxShadow: "none",
};

const PlanImgContainer = styled.div`
  // height: 400px;
  width: calc(100% - 100px);
  display: block;
  position: relative;
`;

const PlanMenuButton = styled.div`
    width:30px;
    height:30px;
    padding-top: 3px;
    padding-left: 3px;
    margin-right: 5px;
    cursor: pointer;
    border: 1px solid;
    border-color: #8080804d;
    border-radius: 4px;
`;



const Data = styled.div`
font-size: 14px;
font-weight: 600;
opacity: 1;
`;

const DataResult = styled.div`
  padding: 0.25rem 0.25rem;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
`;
const DataContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.1rem 1rem;
`;
const DataList = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 0 0.6rem 0;
`;

const cardHeaderStyle = {
  display: 'flex',
  flexFlow: 'row nowrap',
  justifyContent: "space-between",
  alignItems: "center",
  flexDirection: 'row',
  flexWrap: 'nowrap',
};

const cardHeaderIndicatorStyle = {
  display: 'flex',
  flexFlow: 'row nowrap',
  justifyContent: 'flex-start',
  flexDirection: 'row',
  flexWrap: 'nowrap',
  alignItems: 'flex-start',
  paddingTop: '0px',
};
const cardBodyIndicatorStyle = {
  paddingTop: '5px',
  paddingBottom: '5px',
};
const cardBody2DPlanStyle = {
  display: 'flex',
};

const useStyles = makeStyles(styles);
const useStyles2 = makeStyles((theme) => ({
  planicon: {
    display: 'block',
    position: 'absolute',
    cursor: 'pointer',
    background: '#ffffffd6',
    borderRadius: 10,
  },
  planicongreen: {
    display: 'block',
    position: 'absolute',
    cursor: 'pointer',
    color: "#91C73C",
    background: '#ffffffd6',
    borderRadius: 10,
  },
  planmenu: {
    display: 'flex',
    aligItems: "flex-end",
  },
  plansubmenu: {
    display: 'flex',
    marginTop: 7,
    marginLeft: 5,
  },
  planmenuicon: {
    width: "20px",
    height: "20px",
    marginLeft: "1px",
    marginTop: "1px",
  },
  planmenubutton: {
    background: "#FFFFFF"
  },
  planmenubuttonpressed: {
    background: "#91C73C"
  },
  planmenubuttonfspressed: {
    background: "#9798A0"
  },
}));

const setNotification = (status, text) => {
  if (status === "success") {
    NotificationManager.success(text);
  } else {
    NotificationManager.error(text);
  }
};
const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const getDateBeginFromPeriod = (period) => {
  let date = moment();
  if (period === 'oneweek') {
    date = date.add(-7, 'd');
    // date = date.set('h',0);
  }
  return date.format("YYYY-MM-DD");
}
const getDateEndFromPeriod = (period) => {
  let date = moment();
  if (period === 'oneweek') {

    // date = date.set('h',0);
  }
  return date.format("YYYY-MM-DD");
}

const Dashboard = (props) => {
  const targetRef = useRef();
  const classes = useStyles();
  const classes2 = useStyles2();
  const appContext = useContext(AdvancedSearchContext);
  const { architecture } = appContext;

  const { currentWorkspace, editionmode } = props;
  const [wpgrouplist, setWpgrouplist] = useState([]);

  const [connectivityDashboardData, setConnectivityDashboardData] = useState("");
  const [alertsData, setAlertsData] = useState("");

  const [fullpointdata, setFullpointdata] = useState([]);
  const [pointdata, setPointdata] = useState([]);
  const [iotdata, setIotdata] = useState([]);
  const [equipmentdata, setEquipmentdata] = useState([]);
  const [avobboxdata, setAvoboxdata] = useState([]);
  const [lorawanboxdata, setLorawanboxdata] = useState([]);

  const [currentDataItem, setCurrentDataItem] = useState("");

  const [meteringplans, setMeteringplans] = useState([]);
  const [meteringplanlist, setMeteringplanlist] = useState([]);
  const [meteringplan, setMeteringplan] = useState("");
  const [meteringplandetails, setMeteringplandetails] = useState([]);
  const [tree, setTree] = useState([]);
  const [refreshMeteringplan, setRefreshMeteringplan] = useState(false);
  const [openplanitem, setOpenplanitem] = useState(false);
  const [openplanitemdata, setOpenplanitemdata] = useState(false);
  const [currentPlanItem, setCurrentPlanItem] = useState("");

  const [openMenumeteringplan, setOpenmenumeteringplan] = useState(null);
  const [openeditmeteringplan, setOpeneditmeteringplan] = useState(false);
  const [currentMeteringplan, setCurrentMeteringplan] = useState("");
  const [selectedTreeItem, setSelectedTreeItem] = useState("");
  const [opensankey, setOpensankey] = useState(false);

  const [plans2d, setPlans2d] = useState([]);
  const [plan2dlist, setPlan2dlist] = useState([]);
  const [plan2d, setPlan2d] = useState("");
  const [plan2ddetails, setPlan2ddetails] = useState([]);
  const [plan2dfilters, setPland2dFilters] = useState([]);
  const [plan2dfilterseq, setPland2dFilterseq] = useState([]);
  const [plan2dfiltersdata, setPland2dFiltersdata] = useState([]);
  const [plan2dfilterlist, setPlan2dfilterlist] = useState([]);
  const [plan2dfilterlisteq, setPlan2dfilterlisteq] = useState([]);
  const [plan2dfilterlistdata, setPlan2dfilterlistdata] = useState([]);
  const [planpicture, setPlanpicture] = useState([]);
  const [planiotItems, setPlaniotitems] = useState([]);
  const [planeqItems, setPlaneqitems] = useState([]);
  const [planlinkItems, setPlanlinkitems] = useState([]);
  const [plandataItems, setPlandataitems] = useState([]);
  const [plandisplayiot, setPlandisplayiot] = useState(true);
  const [plandisplayeq, setPlandisplayeq] = useState(false);
  const [plandisplaydata, setPlandisplaydata] = useState(false);
  const [planimagesize, setPlanimagesize] = useState();
  const [planiconscolor, setPlaniconscolor] = useState(false);
  const [openMenu2dplan, setOpenmenu2dplan] = useState(null);
  const [onlynames, setOnlynames] = useState(false);
  const [openMenu2dplanitem, setOpenmenu2dplanitem] = useState(null);
  const [openMenu2dplanitemedition, setOpenmenu2dplanitemedition] = useState(null);
  const [openedit2dplan, setOpenedit2dplan] = useState(false);
  const [open2dplanitem, setOpen2dplanitem] = useState(false);
  const [open2dplanviewiot, setOpen2dplanviewiot] = useState(false);
  const [open2dplanviewequipment, setOpen2dplanviewequipment] = useState(false);
  const [current2dplan, setCurrent2dplan] = useState("");
  const [current2dPlanItem, setCurrent2dPlanItem] = useState("");
  const [currentPositionX, setCurrentPositionX] = useState("");
  const [currentPositionY, setCurrentPositionY] = useState("");
  const [planrawdata, setPlanrawdata] = useState([]);
  const [plan1hdata, setPlan1hdata] = useState([]);
  const [plan1ddata, setPlan1ddata] = useState([]);
  const [planDatatime, setPlandatatime] = useState(moment());
  const [plan2dloaded, setPlan2dloaded] = useState(false);
  const [planrefreshdataLock, setPlanrefreshdataLock] = useState(true);
  const [fullscreen2D, setFullscreen2D] = useState(false);
  const [move2ditem, setMove2ditem] = useState(false);
  const [updatemove2ditemposition, setUpdatemove2ditemposition] = useState(false);
  const [saveitembeforemove, setSaveitembeforemove] = useState("");
  const [onblurmove2ditem, setOnblurmove2ditem] = useState(false);
  const [refreshdata, setRefreshdata] = useState(false);
  const [plan2ddefaultview, setPland2ddefaultview] = useState("none");
  const [plan2ddisplaydata, setPlan2ddisplaydata] = useState(true);
  const [plan2ddisplayeq, setPlan2ddisplayeq] = useState(true);
  const [plan2ddisplayiot, setPlan2ddisplayiot] = useState(true);


  const [chart1, setChart1] = useState();
  const [chart2, setChart2] = useState();

  const [indic1, setIndic1] = useState();
  const [indic1Text, setIndic1Text] = useState("");
  const [indic2, setIndic2] = useState();
  const [indic2Text, setIndic2Text] = useState("");
  const [indic3, setIndic3] = useState();
  const [indic3Text, setIndic3Text] = useState("");


  //Metering plan & 2d plan
  const handleOpenplanitemdata = (event) => { setOpenplanitemdata(true); };
  const handleCloseplanitemdata = (event) => { setOpenplanitemdata(false); };

  //Metering plan
  const handleAddMeteringPlan = (event) => {
    setOpenmenumeteringplan(null)
    setCurrentMeteringplan("");
    handleOpenplan();
  }
  const handleEditMeteringPlan = (event) => {
    setOpenmenumeteringplan(null)
    setCurrentMeteringplan(meteringplandetails);
    handleOpenplan();
  }
  const handleDeleteMeteringPlan = (event) => {
    setOpenmenumeteringplan(null)
    axios
      .delete(
        deleteGEBMeteringPlan(meteringplan),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", dashboardText.meteringplandeleted);
          setMeteringplan("");
          handleRefreshMeteringPlan();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  }
  const addPlanItem = () => {
    setCurrentPlanItem("");
    setOpenmenumeteringplan(null)
    handleOpenplanitem();
  }

  const edititem = (item) => {
    setCurrentPlanItem(item.avobitem);
    handleOpenplanitem();
  }
  const deleteitem = (item) => {
    axios
      .delete(
        deleteGEBMeteringPlanItem(item.avobitem.id),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", dashboardText.elementdeleted);
          handleRefreshMeteringPlan();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  }

  const viewitemdata = (item) => {
    setCurrentDataItem(item.avobitem);
    handleOpenplanitemdata();
  }

  const handleOpensankey = (event) => { setOpensankey(true); };
  const handleClosesankey = (event) => { setOpensankey(false); };
  const handleOpenplan = (event) => { setOpeneditmeteringplan(true); };
  const handleCloseplan = (event) => { setOpeneditmeteringplan(false); };
  const handleCloseMenumeteringplan = (event) => { setOpenmenumeteringplan(null) };
  const handleClickMenumeteringplan = (event) => { setOpenmenumeteringplan(event.currentTarget) };
  const handleOpenplanitem = (event) => { setOpenplanitem(true); };
  const handleCloseplanitem = (event) => { setOpenplanitem(false); };
  const handleRefreshMeteringPlan = (event) => { setRefreshMeteringplan(!refreshMeteringplan); };
  const handleMeteringplanChange = (event) => { setMeteringplan(event.target.value); };



  //2d plan

  const handlePlan2dChange = (event) => { setPlan2d(event.target.value); };
  const handlePlan2dfiltersChange = (event) => { setPland2dFilters(event.target.value); };
  const handlePlan2dfilterseqChange = (event) => { setPland2dFilterseq(event.target.value); };
  const handlePlan2dfiltersdataChange = (event) => { setPland2dFiltersdata(event.target.value); };

  const handleOpen2dplan = (event) => { setOpenedit2dplan(true); };
  const handleClose2dplan = (event) => { setOpenedit2dplan(false); };
  const handleOpen2dplanitem = (event) => { setOpen2dplanitem(true); };
  const handleClose2dplanitem = (event) => { setOpen2dplanitem(false); };
  const handleOpen2dplanviewiot = (event) => { setOpen2dplanviewiot(true); };
  const handleClose2dplanviewiot = (event) => { setOpen2dplanviewiot(false); };
  const handleOpen2dplanviewequipment = (event) => { setOpen2dplanviewequipment(true); };
  const handleClose2dplanviewequipment = (event) => { setOpen2dplanviewequipment(false); };

  const handleCloseMenu2dplan = (event) => { setOpenmenu2dplan(null) };
  const handleClickMenu2dplan = (event) => { setOpenmenu2dplan(event.currentTarget) };
  const handleCloseMenu2dplanitem = (event) => { setOpenmenu2dplanitem(null) };
  const handleClickMenu2dplanitem = (event) => {
    event.preventDefault();
    setCurrentPositionX(((event.nativeEvent.offsetX) / (event.target.width)));
    setCurrentPositionY(((event.nativeEvent.offsetY) / (event.target.height)));
    setOpenmenu2dplanitem(
      openMenu2dplanitem === null
        ? {
          mouseX: event.clientX + 2,
          mouseY: event.clientY - 6,
        }
        : null,
    );
  };
  const handleCloseMenu2dItemedit = (event) => { setOpenmenu2dplanitemedition(null) };
  const handleClick2dItemEdit = (event, item) => {
    event.preventDefault();
    if (!move2ditem) {
      setCurrent2dPlanItem(item);
      setOpenmenu2dplanitemedition(
        openMenu2dplanitemedition === null
          ? {
            mouseX: event.clientX + 2,
            mouseY: event.clientY - 6,
          }
          : null,
      );
    }

  }
  const handleClick2dItem = (event, item) => {
    if (item.parameters.layer === 'link') {
      if (plans2d.find((p) => p.id === item.parameters.linkedplan)) {
        setPlan2d(item.parameters.linkedplan);
      }
    }
    else if (item.parameters.layer === 'data') {
      setCurrentDataItem(item);
      handleOpenplanitemdata();
    }
    else if (item.parameters.layer === 'iot') {
      setCurrent2dPlanItem(item);
      handleOpen2dplanviewiot();
    }
    else if (item.parameters.layer === 'equipments') {
      setCurrent2dPlanItem(item);
      handleOpen2dplanviewequipment();
    }
  }
  const handleAdd2dPlan = (event) => {
    setOpenmenu2dplan(null)
    setCurrent2dplan("");
    handleOpen2dplan();
  }
  const handleEdit2dPlan = (event) => {
    setOpenmenu2dplan(null)
    setCurrent2dplan(plan2ddetails);
    handleOpen2dplan();
  }
  const handleDelete2dPlan = (event) => {
    setOpenmenu2dplan(null)
    axios
      .delete(
        deleteGEB2DPlan(plan2d),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", dashboardText.plan2ddeleted);
          setMeteringplan("");
          handleRefresh2dPlanList();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  }
  const add2dPlanItem = () => {
    handleCloseMenu2dplanitem();
    setCurrent2dPlanItem("");
    setOpenmenu2dplan(null)
    handleOpen2dplanitem();
  }
  const edit2dplanitem = (event) => {
    handleCloseMenu2dItemedit();
    handleOpen2dplanitem();
  }
  const move2dplanitem = (event) => {
    handleCloseMenu2dItemedit();
    setMove2ditem(true);
    setSaveitembeforemove({ relativex: current2dPlanItem.parameters.relativex, relativey: current2dPlanItem.parameters.relativey });
  }

  const handleKey = (event) => {
    if (move2ditem) {
      event.preventDefault();
      let offset = 18;
      if (current2dPlanItem.parameters?.iconsize === 'big')
        offset = 22;
      else if (current2dPlanItem.parameters?.iconsize === 'small')
        offset = 12;
      else
        offset = 18;
      if (event.key === 'ArrowLeft') {
        let updatemove2ditempositiont = !updatemove2ditemposition;
        current2dPlanItem.parameters.relativex = Math.round((current2dPlanItem.parameters.relativex - 0.01) * 100) / 100;
        if (current2dPlanItem.parameters.relativex < 0)
          current2dPlanItem.parameters.relativex = 0;
        current2dPlanItem.left = "calc(" + ((current2dPlanItem.parameters.relativex) * 100) + "% - " + offset + "px)";
        setUpdatemove2ditemposition(updatemove2ditempositiont);
      }
      if (event.key === 'ArrowRight') {
        let updatemove2ditempositiont = !updatemove2ditemposition;
        current2dPlanItem.parameters.relativex = Math.round((current2dPlanItem.parameters.relativex + 0.01) * 100) / 100;
        if (current2dPlanItem.parameters.relativex > 100)
          current2dPlanItem.parameters.relativex = 100;
        current2dPlanItem.left = "calc(" + ((current2dPlanItem.parameters.relativex) * 100) + "% - " + offset + "px)";
        setUpdatemove2ditemposition(updatemove2ditempositiont);
      }
      if (event.key === 'ArrowUp') {
        let updatemove2ditempositiont = !updatemove2ditemposition;
        current2dPlanItem.parameters.relativey = Math.round((current2dPlanItem.parameters.relativey - 0.01) * 100) / 100;
        if (current2dPlanItem.parameters.relativey < 0)
          current2dPlanItem.parameters.relativey = 0;
        current2dPlanItem.top = "calc(" + ((current2dPlanItem.parameters.relativey) * 100) + "% - " + offset + "px)";
        setUpdatemove2ditemposition(updatemove2ditempositiont);
      }
      if (event.key === 'ArrowDown') {
        let updatemove2ditempositiont = !updatemove2ditemposition;
        current2dPlanItem.parameters.relativey = Math.round((current2dPlanItem.parameters.relativey + 0.01) * 100) / 100;
        if (current2dPlanItem.parameters.relativey > 100)
          current2dPlanItem.parameters.relativey = 100;
        current2dPlanItem.top = "calc(" + ((current2dPlanItem.parameters.relativey) * 100) + "% - " + offset + "px)";
        setUpdatemove2ditemposition(updatemove2ditempositiont);
      }
      if (event.key === 'Escape') {
        current2dPlanItem.parameters.relativex = saveitembeforemove.relativex;
        current2dPlanItem.parameters.relativey = saveitembeforemove.relativey;
        current2dPlanItem.left = "calc(" + ((current2dPlanItem.parameters.relativex) * 100) + "% - " + offset + "px)";
        current2dPlanItem.top = "calc(" + ((current2dPlanItem.parameters.relativey) * 100) + "% - " + offset + "px)";
        setMove2ditem(false);
        setOnblurmove2ditem(false);
      }
      if (event.key === 'Enter') {
        setMove2ditem(false);
        setOnblurmove2ditem(false);
        update2dplanItem();
      }
    }


  }

  const handleOnBlur = (event) => {
    if (move2ditem) {
      setOnblurmove2ditem(true);
    }
    if (move2ditem && onblurmove2ditem) {
      setOnblurmove2ditem(false);
      let offset = 18;
      if (current2dPlanItem.parameters?.iconsize === 'big')
        offset = 22;
      else if (current2dPlanItem.parameters?.iconsize === 'small')
        offset = 12;
      else
        offset = 18;
      current2dPlanItem.parameters.relativex = saveitembeforemove.relativex;
      current2dPlanItem.parameters.relativey = saveitembeforemove.relativey;
      current2dPlanItem.left = "calc(" + ((current2dPlanItem.parameters.relativex) * 100) + "% - " + offset + "px)";
      current2dPlanItem.top = "calc(" + ((current2dPlanItem.parameters.relativey) * 100) + "% - " + offset + "px)";
      setMove2ditem(false);
    }
  }

  const update2dplanItem = async (event) => {
    let newitemparameters = {
      ...current2dPlanItem.parameters,
    }
    axios
      .put(
        putGEB2dPlanItem(current2dPlanItem.id),
        newitemparameters
        ,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Item modifié");
        } else NotificationManager.error("Une erreur est survenue");
      })
      .catch((error) => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  // useEffect(() => {
  //   console.log('addEventListener');
  //   document.addEventListener("keydown", (event)=>handleKey(event), false);
  // },[] )


  const del2dplanitem = (event) => {
    handleCloseMenu2dItemedit();
    axios
      .delete(
        deleteGEB2dPlanItem(current2dPlanItem.id),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setCurrent2dPlanItem("");
        if (res.status == 200) {
          setNotification("success", dashboardText.elementdeleted);
          handleRefresh2dPlanList(plan2ddetails.id);
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });;
  }

  const handlePlandisplayiotChange = (event) => {
    if (!plandisplayiot) {
      setPlandisplayiot(true);
      setPlandisplayeq(false);
      setPlandisplaydata(false);
    }
  };
  const handlePlandisplayeqChange = (event) => {
    if (!plandisplayeq) {
      setPlandisplayiot(false);
      setPlandisplayeq(true);
      setPlandisplaydata(false);
    }
  };
  const handlePlandisplaydataChange = (event) => {
    if (!plandisplaydata) {
      setPlandisplayiot(false);
      setPlandisplayeq(false);
      setPlandisplaydata(true);
    }
  };
  const handlePlanOnlynamesChange = (event) => {
    setOnlynames(!onlynames);
  };

  const emptyMeteringPlan = () => {
    setMeteringplan("");
    setCurrentMeteringplan("");
    setMeteringplandetails([]);
    setTree([]);
  }
  const empty2dPlan = () => {
    setPlan2d("");
    setCurrent2dplan("");
    setPlan2ddetails([]);
  }

  const getFullscreen2D = () => {
    setFullscreen2D(true);
  };
  const handleFullscreen2DClose = () => {
    setFullscreen2D(false);
  };

  const refetchfullpoints = () => {
    axios
      .get(
        getMBMEquipments(currentWorkspace?.idgroup, 'all'),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setEquipmentdata(res.data.equipments || []);
        setFullpointdata(res.data.points || []);
      })
      .catch(() => { });
  }

  //worskpace
  useEffect(() => {
    setMeteringplanlist([]);
    setMeteringplans([]);
    emptyMeteringPlan();
    empty2dPlan();
    if (currentWorkspace) {
      let wpgrouplisttmp = [];
      let workspacegroup = currentWorkspace.idgroup;
      if (workspacegroup) {
        //dashboard
        axios
          .get(getMBMDashboard(workspacegroup,currentWorkspace.id), {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          })
          .then((res) => {
            let datatmp = [{ name: 'Equipements', actives: res.data?.equipmentsactives, inactives: res.data?.equipmentsinactives, neverseen: res.data?.equipmentsnever },
            { name: 'IoT', actives: res.data?.iotactives, inactives: res.data?.iotinactives, neverseen: res.data?.iotnever },
            { name: 'Boxs', actives: res.data?.avobboxactives, inactives: res.data?.avobboxinactives, neverseen: res.data?.avobboxnever },];
            setConnectivityDashboardData(datatmp);
          });
        //Alerts
        axios
          .get(getAlerts(workspacegroup, null, null, null, null, 'count'), {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          })
          .then((res) => {
            setAlertsData(res.data);
          });
        //points
        axios
          .get(
            getChartpoints(workspacegroup,currentWorkspace.id),
            {
              headers: {
                Authorization: `Bearer ${UserService.getToken()}`,
              },
            }
          )
          .then((res) => {
            setPointdata(res.data.points || []);
          })
          .catch(() => { });

        //iot
        axios
          .get(
            getMBMIotdevices(workspacegroup, currentWorkspace.id),
            {
              headers: {
                Authorization: `Bearer ${UserService.getToken()}`,
              },
            }
          )
          .then((res) => {
            setIotdata(res.data.iotdevices || []);
          })
          .catch(() => { });

        //equipments
        axios
          .get(
            getMBMEquipments(workspacegroup, 'all', 'false', currentWorkspace.id),
            {
              headers: {
                Authorization: `Bearer ${UserService.getToken()}`,
              },
            }
          )
          .then((res) => {
            setEquipmentdata(res.data.equipments || []);
            setFullpointdata(res.data.points || []);
          })
          .catch(() => { });

        //box
        axios
          .get(
            getMBMAVOBBoxs(workspacegroup),
            {
              headers: {
                Authorization: `Bearer ${UserService.getToken()}`,
              },
            }
          )
          .then((res) => {
            let avobboxs = res.data.avobboxs?.filter((box) => box.type != 4) || [];
            setAvoboxdata(avobboxs);
            let lorawanboxs = res.data.avobboxs?.filter((box) => box.type == 4) || [];
            setLorawanboxdata(lorawanboxs);
          })
          .catch(() => { });


        //grouplistfromthisgroup
        searchworkspacegroup(architecture, wpgrouplisttmp, workspacegroup, false, "");
        setWpgrouplist(wpgrouplisttmp);
      }
      //Metering plan
      axios
        .get(getGEBMeteringPlans(currentWorkspace.id), {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
        .then((res) => {
          setMeteringplans(res.data?.meteringplans || []);
          let defaultmeteringplan = "";
          let meteringplanlisttmp = res.data?.meteringplans?.map((meteringplan) => {
            if (meteringplan.parameters?.isdefault)
              defaultmeteringplan = meteringplan.id;
            let name = meteringplan.parameters?.name || '';
            if (meteringplan.idgroup && wpgrouplisttmp.find((group) => group.id == meteringplan.idgroup)) {
              name += " (" + wpgrouplisttmp.find((group) => group.id == meteringplan.idgroup).name + ")";
            }
            return { id: meteringplan.id, name: name }
          }
          );
          setMeteringplanlist(meteringplanlisttmp);
          if (defaultmeteringplan)
            setMeteringplan(defaultmeteringplan);
        });

      //2D Plans
      axios
        .get(getGEB2DPlans(currentWorkspace.id), {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
        .then((res) => {
          setPlans2d(res.data?.plans || []);
          let default2dplan = "";
          let plan2dlisttmp = res.data?.plans?.map((plan) => {
            if (plan.parameters?.isdefault)
              default2dplan = plan.id;
            return { id: plan.id, name: plan.parameters?.name || '' }
          }
          );
          if (currentWorkspace.parameters?.order2dplans) {
            plan2dlisttmp.sort((a, b) => {
              const nameA = a.name.toUpperCase(); // ignorer les majuscules/minuscules
              const nameB = b.name.toUpperCase(); // ignorer les majuscules/minuscules
              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }

              // les noms sont égaux
              return 0;
            });
          }
          setPlan2dlist(plan2dlisttmp);
          if (default2dplan)
            setPlan2d(default2dplan);
        });

      //charts

      let chart1 = currentWorkspace.parameters?.chart1;
      if (chart1) {
        let datebegin = getDateBeginFromPeriod(chart1.period);
        let dateend = getDateEndFromPeriod(chart1.period);
        const requestid = uuid();
        let chartsource = 'existing';
        let url = '';
        if (chart1.version && chart1.version === 'v2') {
          url = getChartV2(workspacegroup, chart1.chart, datebegin, dateend, false, chartsource, '', requestid);
        }
        else {
          url = getChart(workspacegroup, chart1.chart, datebegin, dateend, false, chartsource, '', '', '', '', '', '', '', requestid);
        }
        let datetitle = moment(datebegin).format('DD/MM/yyyy') + " au " + moment(dateend).format('DD/MM/yyyy');
        axios.get(
          url,
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
          .then((response) => {
            let resultchart = {};
            resultchart.serverData = response.data.chart;
            if (resultchart?.serverData?.title)
              resultchart.serverData.title = resultchart.serverData.title + " (" + datetitle + ")";
            if (resultchart?.serverData?.name)
              resultchart.serverData.name = resultchart.serverData.name + " (" + datetitle + ")";
            if (resultchart.serverData.version === 'v1') {
              resultchart = getChartCategoryScript(
                resultchart.serverData?.data,
                resultchart.serverData?.title,
                resultchart.serverData?.category,
                resultchart.serverData?.type,
                resultchart.serverData?.stacking,
                resultchart.chart,
                true
              )[0];
              ;
            }
            else {
              resultchart = getChartCategoryScriptV2(resultchart.serverData, chart1.chart, "", true);
            }
            setChart1(resultchart);
          })
          .catch((error) => {
            console.error(error);
          })
      }
      else
        setChart1("");

      let chart2 = currentWorkspace.parameters?.chart2;
      if (chart2) {
        let datebegin2 = getDateBeginFromPeriod(chart2.period);
        let dateend2 = getDateEndFromPeriod(chart2.period);
        const requestid2 = uuid();
        let chartsource = 'existing';
        let url2 = '';
        if (chart2.version && chart2.version === 'v2') {
          url2 = getChartV2(workspacegroup, chart2.chart, datebegin2, dateend2, false, chartsource, '', requestid2);
        }
        else {
          url2 = getChart(workspacegroup, chart2.chart, datebegin2, dateend2, false, chartsource, '', '', '', '', '', '', '', requestid2);
        }
        let datetitle2 = moment(datebegin2).format('DD/MM/yyyy') + " au " + moment(dateend2).format('DD/MM/yyyy');
        axios.get(
          url2,
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
          .then((response) => {
            let resultchart = {};
            resultchart.serverData = response.data.chart;
            if (resultchart?.serverData?.title)
              resultchart.serverData.title = resultchart.serverData.title + " (" + datetitle2 + ")";
            if (resultchart?.serverData?.name)
              resultchart.serverData.name = resultchart.serverData.name + " (" + datetitle2 + ")";
            if (resultchart.serverData.version === 'v1') {
              resultchart = getChartCategoryScript(
                resultchart.serverData?.data,
                resultchart.serverData?.title,
                resultchart.serverData?.category,
                resultchart.serverData?.type,
                resultchart.serverData?.stacking,
                resultchart.chart,
                true
              )[0];
              ;
            }
            else {
              resultchart = getChartCategoryScriptV2(resultchart.serverData, chart2.chart, "", true);
            }
            setChart2(resultchart);
          })
          .catch((error) => {
            console.error(error);
          })
      }
      else
        setChart2("");

    }
  }, [currentWorkspace]);

  const searchworkspacegroup = (archi, grouplist, wpgroupid, found, fatherpath) => {
    archi.forEach((group) => {
      let newpath = fatherpath + "/" + group.text;
      if (found || group.id == wpgroupid) {
        let newgp = {};
        newgp.name = newpath;
        newgp.id = group.id;
        grouplist.push(newgp);
        found = true;
      }
      if (group.children && group.children.length > 0) {
        searchworkspacegroup(group.children, grouplist, wpgroupid, found, newpath);
      }
    })
  }

  //metering plan
  const handleRefreshMeteringPlanList = (selectedid) => {
    emptyMeteringPlan();
    axios
      .get(getGEBMeteringPlans(currentWorkspace.id), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        setMeteringplans(res.data?.meteringplans || []);
        let defaultmeteringplan = "";
        let meteringplanlisttmp = res.data?.meteringplans?.map((meteringplan) => {
          if (selectedid) {
            if (meteringplan.id == selectedid)
              defaultmeteringplan = meteringplan.id;
          }
          else if (meteringplan.parameters?.isdefault)
            defaultmeteringplan = meteringplan.id;
          let name = meteringplan.parameters?.name || '';
          if (meteringplan.idgroup && wpgrouplist.find((group) => group.id == meteringplan.idgroup)) {
            name += " (" + wpgrouplist.find((group) => group.id == meteringplan.idgroup).name + ")";
          }
          return { id: meteringplan.id, name: name }
        }
        );
        setMeteringplanlist(meteringplanlisttmp);
        if (defaultmeteringplan)
          setMeteringplan(defaultmeteringplan);
      });
  };

  useEffect(() => {
    setTree([]);
    if (meteringplan) {
      axios
        .get(getGEBMeteringPlan(meteringplan), {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
        .then((res) => {
          let sortedmeteringplan = { ...res.data };
          if (res.data.items) {
            let sorteditems = res.data.items.sort((a, b) => {
              const nameA = a.parameters.name.toUpperCase(); // ignore upper and lowercase
              const nameB = b.parameters.name.toUpperCase(); // ignore upper and lowercase
              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }

              // names must be equal
              return 0;
            });
            sortedmeteringplan.items = sorteditems;
          }

          setMeteringplandetails(sortedmeteringplan || "");
        });
    }
  }, [meteringplan, refreshMeteringplan]);

  useEffect(() => {
    if (meteringplandetails && meteringplandetails.items) {
      let treetmp = [];
      let search = meteringplandetails.items?.filter((item) => !item.father);
      search.forEach((item) => {
        let leaf = {};
        leaf.label = item.parameters.name;
        leaf.id = "" + item.id;
        leaf.avobid = item.id;
        leaf.icon = item.parameters.icon;
        leaf.valuetype = item.parameters.valuetype;
        leaf.avobitem = item;
        let leafchilds = fillchilds(leaf);
        if (leafchilds.length > 0)
          leaf.children = leafchilds;
        treetmp.push(leaf);
      });
      setTree(treetmp);
    }
  }, [meteringplandetails]);

  const fillchilds = (father) => {
    let childs = [];
    let search = meteringplandetails.items?.filter((item) => item.father === father.avobid);
    search.forEach((item) => {
      let leaf = {};
      leaf.label = item.parameters.name;
      leaf.id = "" + item.id;
      leaf.avobid = item.id;
      leaf.icon = item.parameters.icon;
      leaf.valuetype = item.parameters.valuetype;
      leaf.avobitem = item;
      let leafchilds = fillchilds(leaf);
      if (leafchilds.length > 0)
        leaf.children = leafchilds;
      childs.push(leaf);
    });
    return childs;
  }


  //2dplan
  const handleRefresh2dPlanList = (selectedid) => {
    empty2dPlan();
    axios
      .get(getGEB2DPlans(currentWorkspace.id), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        setPlans2d(res.data?.plans || []);
        let default2dplan = "";
        let selectedplan = "";
        let plan2dlisttmp = res.data?.plans?.map((plan) => {
          if (selectedid && plan.id == selectedid) {
            selectedplan = plan.id;
          }
          if (plan.parameters?.isdefault)
            default2dplan = plan.id;
          return { id: plan.id, name: plan.parameters?.name || '' }
        }
        );
        if (currentWorkspace.parameters?.order2dplans) {
          plan2dlisttmp.sort((a, b) => {
            const nameA = a.name.toUpperCase(); // ignorer les majuscules/minuscules
            const nameB = b.name.toUpperCase(); // ignorer les majuscules/minuscules
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }

            // les noms sont égaux
            return 0;
          });
        }
        setPlan2dlist(plan2dlisttmp);
        if (selectedplan)
          setPlan2d(selectedplan);
        else if (default2dplan)
          setPlan2d(default2dplan);
      });
  };

  useEffect(() => {
    if (plan2d) {
      axios
        .get(getGEB2DPlan(plan2d), {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
        .then((res) => {
          setPlan2ddetails(res.data || "");
        });
    }
  }, [plan2d]);

  useEffect(() => {
    if (plan2ddetails && plan2ddetails.parameters) {
      if ("defaultview" in plan2ddetails.parameters) {
        let defaultviewtmp = plan2ddetails.parameters.defaultview;
        setPland2ddefaultview(defaultviewtmp);
        setPlan2ddisplaydata(plan2ddetails.parameters.displaydata);
        setPlan2ddisplayeq(plan2ddetails.parameters.displayeq);
        setPlan2ddisplayiot(plan2ddetails.parameters.displayiot);
        if (defaultviewtmp === "none") {
          if (plandisplayiot && !plan2ddetails.parameters.displayiot) {
            setPlandisplayiot(false);
            if (plan2ddetails.parameters.displayeq)
              setPlandisplayeq(true);
            else
              setPlandisplaydata(true);
          }
          else if (plandisplayeq && !plan2ddetails.parameters.displayeq) {
            setPlandisplayeq(false);
            if (plan2ddetails.parameters.displayiot)
              setPlandisplayiot(true);
            else
              setPlandisplaydata(true);
          }
          else if (plandisplaydata && !plan2ddetails.parameters.displaydata) {
            setPlandisplaydata(false);
            if (plan2ddetails.parameters.displayiot)
              setPlandisplayiot(true);
            else
              setPlandisplayeq(true);
          }
        }
        else if (defaultviewtmp === 'iot') {
          setPlandisplayiot(true);
          setPlandisplayeq(false);
          setPlandisplaydata(false);
        }
        else if (defaultviewtmp === 'eq') {
          setPlandisplayiot(false);
          setPlandisplayeq(true);
          setPlandisplaydata(false);
        }
        else if (defaultviewtmp === 'data') {
          setPlandisplayiot(false);
          setPlandisplayeq(false);
          setPlandisplaydata(true);
        }
      }
      else {
        setPland2ddefaultview("none");
        setPlan2ddisplaydata(true);
        setPlan2ddisplayeq(true);
        setPlan2ddisplayiot(true);
      }
    }

    if (plan2ddetails && plan2ddetails.parameters?.image) {
      setPlan2dloaded(false);
      axios
        .get(downloadFile(plan2ddetails.parameters.image.fileId), {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const imageElement = document.getElementById("planid");
          imageElement.src = url;
          imageElement.onload = () => {
            setPlanimagesize({ width: imageElement.width, height: imageElement.height });
            let planiotItemstmp = [];
            let planeqItemstmp = [];
            let plandataItemstmp = [];
            let planlinkItemstmp = [];
            let plan2dfilterlisttmp = [];
            let plan2dfilterlisteqtmp = [];
            let plan2dfilterlistdatatmp = [];
            // plan2dfilterlisttmp.push({ id: 'allitems', name: dashboardText.filterallitems });
            if (plan2ddetails.items && plan2ddetails.items.length > 0) {
              plan2ddetails.items.forEach((item) => {
                let offset = 18;
                if (item.parameters?.iconsize === 'big')
                  offset = 22;
                else if (item.parameters?.iconsize === 'small')
                  offset = 12;
                else
                  offset = 18;
                let planitem = { ...item };
                planitem.left = "calc(" + item.parameters.relativex * 100 + "% - " + offset + "px)";
                planitem.top = "calc(" + item.parameters.relativey * 100 + "% - " + offset + "px)";
                if (item.parameters.layer === 'iot') {
                  planiotItemstmp.push(planitem);
                  let iottmp = iotdata.find((i) => i.id == planitem.parameters?.iot);
                  if (iottmp) {
                    if (!plan2dfilterlisttmp.find((d) => d.id == iottmp.definition)) {
                      let deftext = iotdefinitiondata.find((x) => x.id == iottmp?.definition)?.name;
                      plan2dfilterlisttmp.push({ id: iottmp.definition, name: deftext });
                    }
                  }

                }

                else if (item.parameters.layer === 'avobbox')
                  planiotItemstmp.push(planitem);
                else if (item.parameters.layer === 'lorawanbox')
                  planiotItemstmp.push(planitem);
                else if (item.parameters.layer === 'equipments') {
                  planeqItemstmp.push(planitem);
                  let eqtmp = equipmentdata.find((i) => i.id == planitem.parameters?.equipment);
                  if (eqtmp) {
                    if (!plan2dfilterlisteqtmp.find((d) => d.id == eqtmp.definition)) {
                      let deftext = eqdefinitionData.find((x) => x.id == eqtmp?.definition)?.name;
                      plan2dfilterlisteqtmp.push({ id: eqtmp.definition, name: deftext });
                    }
                  }
                }

                else if (item.parameters.layer === 'data') {
                  plandataItemstmp.push(planitem);
                  let pointtmp = fullpointdata.find((pt) => pt.id == planitem.parameters?.value);
                  if (pointtmp) {
                    let deftext = dico.find((x) => x.id == pointtmp.definition)?.name;
                    if (pointtmp.equipment) {
                      let eqtmp = equipmentdata.find((i) => i.id == pointtmp.equipment);
                      if (eqtmp) {
                        let eqdeftext = eqdefinitionData.find((x) => x.id == eqtmp?.definition)?.name;
                        if (!plan2dfilterlistdatatmp.find((d) => d.id === pointtmp.definition + "_" + eqtmp.definition)) {
                          plan2dfilterlistdatatmp.push({ id: pointtmp.definition + "_" + eqtmp.definition, name: eqdeftext + " : " + deftext });
                        }
                      }

                    }
                  }
                }

                else if (item.parameters.layer === 'link')
                  planlinkItemstmp.push(planitem);
              });

            }
            setPlaniotitems(planiotItemstmp);
            setPlaneqitems(planeqItemstmp);
            setPlandataitems(plandataItemstmp);
            setPlanlinkitems(planlinkItemstmp);
            setPlan2dloaded(true);
            setPlan2dfilterlist(plan2dfilterlisttmp);
            setPland2dFilters([]);
            setPlan2dfilterlisteq(plan2dfilterlisteqtmp);
            setPland2dFilterseq([]);
            setPlan2dfilterlistdata(plan2dfilterlistdatatmp);
            setPland2dFiltersdata([]);
            //get data
            // console.log(plan2dfilterlisttmp);
            // console.log(plan2dfilterlisteqtmp);
            // console.log(plan2dfilterlistdatatmp);
            // console.log(plandataItemstmp);
            // getPlan2DData(plandataItemstmp);
          };

        });
    }
  }, [plan2ddetails]);

  useEffect(() => {
    if (plan2dloaded && pointdata && pointdata.length > 0) {
      getPlan2DData(plandataItems, planeqItems);
    }
  }, [plandataItems, pointdata, planeqItems, plan2dloaded]);

  const refreshPlan2DData = () => {
    if (!planrefreshdataLock)
      //setRefreshdata(!refreshdata);
      getPlan2DData(plandataItems, planeqItems);
  }

  const getPlan2DData = (plandataItems, planeqItems) => {
    setPlandatatime(moment());
    //iot
    axios
      .get(
        getMBMIotdevices(currentWorkspace.idgroup, currentWorkspace.id),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setIotdata(res.data.iotdevices || []);
        if (plan2ddetails.items && plan2ddetails.items.length > 0 && res.data.iotdevices && res.data.iotdevices.length > 0) {
          let plan2dfilterlisttmp = [];
          plan2ddetails.items.forEach((item) => {
            if (item.parameters.layer === 'iot') {
              let iottmp = res.data.iotdevices.find((i) => i.id == item.parameters?.iot);
              if (iottmp) {
                if (!plan2dfilterlisttmp.find((d) => d.id == iottmp.definition)) {
                  let deftext = iotdefinitiondata.find((x) => x.id == iottmp?.definition)?.name;
                  plan2dfilterlisttmp.push({ id: iottmp.definition, name: deftext });
                }
              }

            }
          });
          setPlan2dfilterlist(plan2dfilterlisttmp);
        }

      })
      .catch(() => { });

    //equipments
    axios
      .get(
        getMBMEquipments(currentWorkspace.idgroup, 'all', 'false', currentWorkspace.id),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setEquipmentdata(res.data.equipments || []);
        setFullpointdata(res.data.points || []);
        if (plan2ddetails.items && plan2ddetails.items.length > 0 && res.data.equipments && res.data.points) {
          let plan2dfilterlisteqtmp = [];
          let plan2dfilterlistdatatmp = [];
          plan2ddetails.items.forEach((item) => {
            if (item.parameters.layer === 'equipments') {
              let eqtmp = res.data.equipments.find((i) => i.id == item.parameters?.equipment);
              if (eqtmp) {
                if (!plan2dfilterlisteqtmp.find((d) => d.id == eqtmp.definition)) {
                  let deftext = eqdefinitionData.find((x) => x.id == eqtmp?.definition)?.name;
                  plan2dfilterlisteqtmp.push({ id: eqtmp.definition, name: deftext });
                }
              }
            }
            else if (item.parameters.layer === 'data') {
              let pointtmp = res.data.points.find((pt) => pt.id == item.parameters?.value);
              if (pointtmp) {
                let deftext = dico.find((x) => x.id == pointtmp.definition)?.name;
                if (pointtmp.equipment) {
                  let eqtmp = res.data.equipments.find((i) => i.id == pointtmp.equipment);
                  if (eqtmp) {
                    let eqdeftext = eqdefinitionData.find((x) => x.id == eqtmp?.definition)?.name;
                    if (!plan2dfilterlistdatatmp.find((d) => d.id === pointtmp.definition + "_" + eqtmp.definition)) {
                      plan2dfilterlistdatatmp.push({ id: pointtmp.definition + "_" + eqtmp.definition, name: eqdeftext + " : " + deftext });
                    }
                  }
                }
              }
            }
          });
          setPlan2dfilterlisteq(plan2dfilterlisteqtmp);
          setPlan2dfilterlistdata(plan2dfilterlistdatatmp);
        }


      })
      .catch(() => { });

    //box
    axios
      .get(
        getMBMAVOBBoxs(currentWorkspace.idgroup),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        let avobboxs = res.data.avobboxs?.filter((box) => box.type != 4) || [];
        setAvoboxdata(avobboxs);
        let lorawanboxs = res.data.avobboxs?.filter((box) => box.type == 4) || [];
        setLorawanboxdata(lorawanboxs);
      })
      .catch(() => { });

    let pointidsraw = [];
    let pointids1h = [];
    let pointids1d = [];
    plandataItems.forEach((item) => {
      let point = pointdata.find((pt) => pt.id == item.parameters.value);
      if (point) {
        if (item.parameters?.valueagg === 'raw')
          pointidsraw.push("" + point.id);
        else if (item.parameters?.valueagg === 'hour')
          pointids1h.push("" + point.pointid);
        else if (item.parameters?.valueagg === 'day')
          pointids1d.push("" + point.pointid);
      }
    })
    planeqItems.forEach((item) => {
      if (item.parameters.value) {
        let point = pointdata.find((pt) => pt.id == item.parameters.value);
        if (point) {
          if (item.parameters?.valueagg === 'raw')
            pointidsraw.push("" + point.id);
          else if (item.parameters?.valueagg === 'hour')
            pointids1h.push("" + point.pointid);
          else if (item.parameters?.valueagg === 'day')
            pointids1d.push("" + point.pointid);
        }
      }
    })
    let lock = 0;
    if (pointidsraw.length > 0)
      lock++;
    if (pointids1h.length > 0)
      lock++;
    if (pointids1d.length > 0)
      lock++;

    let datebegin = moment().subtract(1, 'week').format("YYYY-MM-DD");
    let dateend = moment().format("YYYY-MM-DD");
    if (pointidsraw.length > 0) {
      setPlanrefreshdataLock(true);
      let request = {
        datebegin,
        dateend,
        method: 'raw',
        pointids: pointidsraw,
        app: "" //to delete after maj
      }
      axios
        .post(postMBMPointData(),
          request,
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
              'Content-Type': "application/json; charset=utf-8",
            },
          })
        .then((res) => {
          pointidsraw.forEach((id) => {
            if (res.data[id]) {
              let sorteddata = res.data[id].sort((a, b) => a.date - b.date);
              sorteddata.forEach((d) => d.value = d.value.replace(",", "."));
              res.data[id] = sorteddata;
            }
          });
          setPlanrawdata(res.data);
          lock--;
          if (lock === 0)
            setPlanrefreshdataLock(false);
        });
    }

    if (pointids1h.length > 0) {
      setPlanrefreshdataLock(true);
      let request = {
        datebegin,
        dateend,
        method: '1h',
        pointids: pointids1h,
        app: "" //to delete after maj
      }
      axios
        .post(postMBMPointData(),
          request,
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
              'Content-Type': "application/json; charset=utf-8",
            },
          })
        .then((res) => {
          pointids1h.forEach((id) => {
            if (res.data[id]) {
              let sorteddata = res.data[id].sort((a, b) => a.date - b.date);
              res.data[id] = sorteddata;
            }
          });
          setPlan1hdata(res.data);
          lock--;
          if (lock === 0)
            setPlanrefreshdataLock(false);
        });
    }
    if (pointids1d.length > 0) {
      setPlanrefreshdataLock(true);
      let request = {
        datebegin,
        dateend,
        method: '1d',
        pointids: pointids1d,
        app: "" //to delete after maj
      }
      axios
        .post(postMBMPointData(),
          request,
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
              'Content-Type': "application/json; charset=utf-8",
            },
          })
        .then((res) => {
          pointids1d.forEach((id) => {
            if (res.data[id]) {
              let sorteddata = res.data[id].sort((a, b) => a.date - b.date);
              res.data[id] = sorteddata;
            }
          });
          setPlan1ddata(res.data);
          lock--;
          if (lock === 0)
            setPlanrefreshdataLock(false);
        });
    }
  }

  // useEffect(() => {
  //   const timeoutId = setTimeout(() => {
  //     // console.log('timeout');
  //     // if (planiotItems && planiotItems.length > 0) {
  //     //   console.log(planiconscolor);
  //     //   let planiotItemstmp = [...planiotItems];
  //     //   planiotItemstmp.forEach((item) => {
  //     //     item.className = planiconscolor ? classes2.planicongreen : classes2.planicon;
  //     //   });
  //     //   setPlaniotitems(planiotItemstmp);
  //     // }
  //     setPlaniconscolor(!planiconscolor);
  //   }, 2000);
  //   return () => clearTimeout(timeoutId);
  // }, [planiconscolor]);

  const getPlanItem = (rawitem, imgwidth, imgheight) => {
    if (rawitem.parameters) {
      let positionx = rawitem.parameters.relativex * imgwidth;
      let positiony = rawitem.parameters.relativey * imgheight;
      if (rawitem.parameters.icontype === 'AcUnitIcon')
        return <AcUnitIcon className={classes2.planicon} style={{ top: positiony, left: positionx }}></AcUnitIcon>
      else if (rawitem.parameters.icontype === 'ElectricMeterIcon')
        return <ElectricMeterIcon className={classes2.planicon} style={{ top: positiony, left: positionx }}></ElectricMeterIcon>
      else if (rawitem.parameters.icontype === 'SpeakerPhoneIcon')
        return <SpeakerPhoneIcon className={classes2.planicon} style={{ top: positiony, left: positionx }}></SpeakerPhoneIcon>
    }
  }

  const getPositionOnImage = (event) => {
    console.log(event);
    console.log({ top: ((event.nativeEvent.layerY) - 10), left: ((event.nativeEvent.layerX) - 10) });
    console.log({ top: (((event.nativeEvent.offsetY) / (event.target.height))), left: (((event.nativeEvent.offsetX) / (event.target.width))) });
    // let plantechnicalItemstmp = [...plantechnicalItems];
    // let item1 = <AcUnitIcon className={classes2.planicon} style={{ top: ((event.nativeEvent.layerY) - 10), left: ((event.nativeEvent.layerX) - 10) }}></AcUnitIcon>
    // plantechnicalItemstmp.push(item1);
    // setPlantechnicalitems(plantechnicalItemstmp);
  }


  return (
    <>
      {
        currentWorkspace ?
          <>
            {
              ((connectivityDashboardData || alertsData) && !fullscreen2D) ?
                <GridItem xs={12} sm={12} md={12} lg={12}>
                  <GridContainer >
                    <GridItem xs={12} sm={12} md={3} lg={3}>
                      {chart1}
                      {/* <Card style={{ height: '250px', marginTop: '10px', marginBottom: '10px' }}>
                          <CardHeader style={cardHeaderIndicatorStyle}>
                            <h4 className={classes.cardIconTitleSimpleCard}>{indic1Text}</h4>
                          </CardHeader>
                          <CardBody style={cardBodyIndicatorStyle}>
                            {indic1}
                          </CardBody>
                        </Card> */}
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3} lg={3}>
                      {chart2}
                      {/* <Card style={{ height: '250px', marginTop: '10px', marginBottom: '10px' }}>
                          <CardHeader style={cardHeaderIndicatorStyle}>
                            <h4 className={classes.cardIconTitleSimpleCard}>{indic2Text}</h4>
                          </CardHeader>
                          <CardBody style={cardBodyIndicatorStyle}>
                            {indic2}
                          </CardBody>
                        </Card> */}
                    </GridItem>
                    {
                      connectivityDashboardData ?
                        <GridItem xs={12} sm={12} md={3} lg={3}>
                          <Card style={{ height: '329px', marginTop: '15px', marginBottom: '10px' }}>
                            <CardHeader style={cardHeaderIndicatorStyle}>
                              <h4 className={classes.cardIconTitleSimpleCard}>{dashboardText.equipmentstatus}</h4>
                            </CardHeader>
                            <CardBody style={cardBodyIndicatorStyle}>
                              <Columns
                                data={connectivityDashboardData}
                              ></Columns>
                            </CardBody>
                          </Card>
                        </GridItem> : <></>
                    }
                    {
                      alertsData ?
                        <GridItem xs={12} sm={12} md={3} lg={3}>
                          <Card style={{ height: '329px', marginTop: '15px', marginBottom: '10px' }}>
                            <CardHeader style={cardHeaderIndicatorStyle}>
                              <h4 className={classes.cardIconTitleSimpleCard}>{dashboardText.alerts}</h4>
                            </CardHeader>
                            <CardBody style={cardBodyIndicatorStyle}>
                              <DataList>
                                <DataContainer>
                                  <Data>{dashboardText.alertcritical + " : "}</Data>
                                  <DataResult>{(alertsData.unreadcritical + alertsData.progresscritical)}</DataResult>
                                </DataContainer>
                                <DataContainer>
                                  <Data>{dashboardText.alertimportant + " : "}</Data>
                                  <DataResult>{(alertsData.unreadimportant + alertsData.progressimportant)}</DataResult>
                                </DataContainer>
                                <DataContainer>
                                  <Data>{dashboardText.alertwarning + " : "}</Data>
                                  <DataResult>{(alertsData.unreadwarning + alertsData.progresswarning)}</DataResult>
                                </DataContainer>
                                <DataContainer>
                                  <Data>{dashboardText.alertinfo + " : "}</Data>
                                  <DataResult>{(alertsData.unreadinfo + alertsData.progressinfo)}</DataResult>
                                </DataContainer>
                              </DataList>
                            </CardBody>
                          </Card>
                        </GridItem>
                        : <></>
                    }

                  </GridContainer>
                </GridItem>
                : <></>
            }

            <GridItem xs={12} sm={12} md={12} lg={12}>
              <GridContainer >
                {
                  fullscreen2D ?
                    <></> :
                    <GridItem xs={12} sm={12} md={4} lg={4}>
                      <GridContainer >
                        {/* AUTOMATION */}
                        {currentWorkspace.parameters?.displayAutomationWidget &&
                          <GridItem xs={12} sm={12} md={12} lg={12}>
                            <AutomationWidget
                              editionmode={editionmode}
                              fullpoints={fullpointdata}
                              points={pointdata}
                              iots={iotdata}
                              equipments={equipmentdata}
                              workspace={currentWorkspace}
                            >
                            </AutomationWidget>
                          </GridItem>
                        }



                        {/* METERING PLAN */}
                        <GridItem xs={12} sm={12} md={12} lg={12}>
                          <Card style={{ marginTop: '10px' }}>
                            <CardHeader style={cardHeaderStyle}>
                              <div>
                                <CustomSelect
                                  marginTop={5}
                                  width={200}
                                  inputTitle={dashboardText.meterplan}
                                  selectValue={meteringplan}
                                  handleSelectValueChange={handleMeteringplanChange}
                                  data={meteringplanlist}
                                  small
                                />
                              </div>
                              <div className={classes2.planmenu}>
                                {
                                  meteringplan ?
                                    <Button
                                      id="sankey-button"
                                      onClick={handleOpensankey}
                                      style={menuButtonStyle}
                                    >
                                      <ShowChartIcon />
                                    </Button>
                                    :
                                    <></>
                                }
                                {editionmode ?
                                  <>
                                    <Button
                                      id="basic-button"
                                      aria-controls={openMenumeteringplan ? 'basic-menu' : undefined}
                                      aria-haspopup="true"
                                      aria-expanded={openMenumeteringplan ? 'true' : undefined}
                                      onClick={handleClickMenumeteringplan}
                                      style={menuButtonStyle}
                                    >
                                      <MenuIcon />
                                    </Button>
                                    <Menu
                                      id="basic-menu"
                                      anchorEl={openMenumeteringplan}
                                      open={Boolean(openMenumeteringplan)}
                                      onClose={handleCloseMenumeteringplan}
                                      MenuListProps={{
                                        'aria-labelledby': 'basic-button',
                                      }}
                                    >
                                      <MenuItem onClick={handleAddMeteringPlan} key={`handleaddplan`}>
                                        {dashboardText.menumeteringplanaddplan}
                                      </MenuItem>
                                      {
                                        meteringplan &&
                                        <MenuItem onClick={handleDeleteMeteringPlan} key={`handledelplan`}>
                                          {dashboardText.menumeteringplandelplan}
                                        </MenuItem>
                                      }
                                      {
                                        meteringplan &&
                                        <MenuItem onClick={handleEditMeteringPlan} key={`handleeditplan`}>
                                          {dashboardText.menumeteringplaneditplan}
                                        </MenuItem>
                                      }
                                      {
                                        meteringplan &&
                                        <MenuItem onClick={addPlanItem} key={`handleaddplanitem`}>
                                          {dashboardText.menumeteringplanadditem}
                                        </MenuItem>
                                      }
                                    </Menu>
                                  </>
                                  : <></>
                                }
                              </div>
                            </CardHeader>
                            <CardBody>
                              {/* <SimpleTreeView
                    aria-label="file system navigator"
                    sx={{ height: "100%", flexGrow: 1, maxWidth: 400, overflowY: 'auto' }}
                  >
                    {treedom}
                  </SimpleTreeView> */}
                              {tree.length > 0 ?
                                <MeteringPlanTree
                                  items={tree}
                                  viewitemdata={viewitemdata}
                                  editionmode={editionmode}
                                  edititem={edititem}
                                  deleteitem={deleteitem}
                                  selected={selectedTreeItem}
                                  setSelected={setSelectedTreeItem}
                                />
                                : <></>
                              }
                            </CardBody>
                          </Card>
                        </GridItem>
                      </GridContainer>
                    </GridItem>
                }

                <GridItem xs={12} sm={12} md={fullscreen2D ? 12 : 8} lg={fullscreen2D ? 12 : 8}>
                  <GridContainer sx={{ height: "100%" }}>
                    <GridItem xs={12} sm={12} md={12} lg={12}>
                      {/* 2D PLAN */}
                      <Card style={{ height: "calc(100% - 30px)", marginTop: '10px' }}>
                        <CardHeader style={cardHeaderStyle}>
                          <div>
                            <CustomSelect
                              marginTop={5}
                              width={200}
                              inputTitle={dashboardText.plan}
                              selectValue={plan2d}
                              handleSelectValueChange={handlePlan2dChange}
                              data={plan2dlist}
                              small
                            />
                          </div>
                          {
                            plandisplayiot ?
                              <div>
                                <CustomSelect
                                  marginTop={5}
                                  width={200}
                                  inputTitle={dashboardText.filters}
                                  selectValue={plan2dfilters}
                                  handleSelectValueChange={handlePlan2dfiltersChange}
                                  data={plan2dfilterlist}
                                  small
                                  multiple
                                />
                              </div> :
                              <></>
                          }
                          {
                            plandisplayeq ?
                              <div>
                                <CustomSelect
                                  marginTop={5}
                                  width={200}
                                  inputTitle={dashboardText.filters}
                                  selectValue={plan2dfilterseq}
                                  handleSelectValueChange={handlePlan2dfilterseqChange}
                                  data={plan2dfilterlisteq}
                                  small
                                  multiple
                                />
                              </div> :
                              <></>
                          }
                          {
                            plandisplaydata ?
                              <div>
                                <CustomSelect
                                  marginTop={5}
                                  width={200}
                                  inputTitle={dashboardText.filters}
                                  selectValue={plan2dfiltersdata}
                                  handleSelectValueChange={handlePlan2dfiltersdataChange}
                                  data={plan2dfilterlistdata}
                                  small
                                  multiple
                                />
                              </div> :
                              <></>
                          }

                          <div className={classes2.planmenu}>
                            <div className={classes2.plansubmenu}>
                              {
                                plan2ddisplayiot &&
                                <Tooltip title={dashboardText.displayiot}>
                                  <PlanMenuButton
                                    color={"success"}
                                    className={plandisplayiot ? classes2.planmenubuttonpressed : classes2.planmenubutton}
                                    onClick={handlePlandisplayiotChange}
                                  >
                                    <WifiIcon className={classes2.planmenuicon} />
                                  </PlanMenuButton>
                                </Tooltip>
                              }
                              {
                                plan2ddisplayeq &&
                                <Tooltip title={dashboardText.displayeq}>
                                  <PlanMenuButton
                                    color={"success"}
                                    className={plandisplayeq ? classes2.planmenubuttonpressed : classes2.planmenubutton}
                                    onClick={handlePlandisplayeqChange}
                                  >
                                    <SpeedIcon className={classes2.planmenuicon} />
                                  </PlanMenuButton>
                                </Tooltip>
                              }
                              {
                                plan2ddisplaydata &&
                                <Tooltip title={dashboardText.displaydata}>
                                  <PlanMenuButton
                                    color={"success"}
                                    className={plandisplaydata ? classes2.planmenubuttonpressed : classes2.planmenubutton}
                                    onClick={handlePlandisplaydataChange}
                                  >
                                    <ShowChartIcon className={classes2.planmenuicon} />
                                  </PlanMenuButton>
                                </Tooltip>
                              }
                              <Tooltip title={dashboardText.refresh} style={{ marginLeft: "15px" }}>
                                <PlanMenuButton
                                  color={"success"}
                                  onClick={refreshPlan2DData}
                                  className={planrefreshdataLock ? classes2.planmenubuttonfspressed : classes2.planmenubutton}
                                  disabled={planrefreshdataLock}
                                >
                                  <RefreshIcon />
                                </PlanMenuButton>
                              </Tooltip>
                              <Tooltip title={dashboardText.displayonlynames}>
                                <PlanMenuButton
                                  color={"success"}
                                  className={onlynames ? classes2.planmenubuttonpressed : classes2.planmenubutton}
                                  onClick={handlePlanOnlynamesChange}
                                >
                                  <Abc className={classes2.planmenuicon} />
                                </PlanMenuButton>
                              </Tooltip>
                              <Tooltip title={dashboardText.fullscreen}>
                                <PlanMenuButton
                                  color={"success"}
                                  className={fullscreen2D ? classes2.planmenubuttonfspressed : classes2.planmenubutton}
                                  onClick={fullscreen2D ? handleFullscreen2DClose : getFullscreen2D}
                                >
                                  <FullscreenIcon className={classes2.planmenuicon} />
                                </PlanMenuButton>
                              </Tooltip>
                            </div>
                            {editionmode ?
                              <>
                                <Button
                                  id="basic-button2"
                                  aria-controls={openMenu2dplan ? 'basic-menu2' : undefined}
                                  aria-haspopup="true"
                                  aria-expanded={openMenu2dplan ? 'true' : undefined}
                                  onClick={handleClickMenu2dplan}
                                  style={menuButtonStyle}
                                >
                                  <MenuIcon />
                                </Button>
                                <Menu
                                  id="basic-menu2"
                                  anchorEl={openMenu2dplan}
                                  open={Boolean(openMenu2dplan)}
                                  onClose={handleCloseMenu2dplan}
                                  MenuListProps={{
                                    'aria-labelledby': 'basic-button2',
                                  }}
                                >
                                  <MenuItem onClick={handleAdd2dPlan} key={`handleadd2dplan`}>
                                    {dashboardText.menu2dplanaddplan}
                                  </MenuItem>
                                  {
                                    plan2d &&
                                    <MenuItem onClick={handleDelete2dPlan} key={`handledel2dplan`}>
                                      {dashboardText.menu2dplandelplan}
                                    </MenuItem>
                                  }
                                  {
                                    plan2d &&
                                    <MenuItem onClick={handleEdit2dPlan} key={`handleedit2dplan`}>
                                      {dashboardText.menu2dplaneditplan}
                                    </MenuItem>
                                  }
                                </Menu>
                              </>
                              : <></>
                            }
                          </div>
                        </CardHeader>
                        <CardBody >
                          {
                            plan2d ?
                              <>
                                {
                                  plandisplaydata ?
                                    <Plan2dSlider style={{ width: '60%', margin: '15px 0 15px 10%' }}
                                      endDate={moment()}
                                      planDatatime={planDatatime}
                                      setPlandatatime={setPlandatatime}
                                      refreshPlan2DData={refreshPlan2DData}
                                      planrefreshdataLock={planrefreshdataLock}
                                    />
                                    : <></>
                                }

                                <PlanImgContainer
                                  onKeyDown={handleKey}
                                  tabIndex="0"
                                  onBlur={handleOnBlur}
                                >

                                  <img id="planid"
                                    alt=""
                                    style={{ width: "100%" }}
                                    ref={targetRef}
                                    onContextMenu={editionmode ? handleClickMenu2dplanitem : undefined}
                                  />

                                  {/* Menu d'ajout d'un élément */}
                                  <Menu
                                    id="basic-menu3"
                                    anchorReference="anchorPosition"
                                    anchorPosition={
                                      openMenu2dplanitem !== null
                                        ? { top: openMenu2dplanitem.mouseY, left: openMenu2dplanitem.mouseX }
                                        : undefined
                                    }
                                    open={Boolean(openMenu2dplanitem)}
                                    onClose={handleCloseMenu2dplanitem}
                                  >
                                    <MenuItem onClick={add2dPlanItem} key={`handleadd2dplanitem`}>
                                      {dashboardText.menu2dplanadditem}
                                    </MenuItem>
                                  </Menu>
                                  {/* Menu d'édition d'un élément */}
                                  <Menu
                                    id="basic-menu4"
                                    anchorReference="anchorPosition"
                                    anchorPosition={
                                      openMenu2dplanitemedition !== null
                                        ? { top: openMenu2dplanitemedition.mouseY, left: openMenu2dplanitemedition.mouseX }
                                        : undefined
                                    }
                                    open={Boolean(openMenu2dplanitemedition && !move2ditem)}
                                    onClose={handleCloseMenu2dItemedit}
                                  >
                                    <MenuItem onClick={edit2dplanitem} key={`handleedit2dplanitem`}>
                                      {dashboardText.editplanitem}
                                    </MenuItem>
                                    <MenuItem onClick={del2dplanitem} key={`handledel2dplanitem`}>
                                      {dashboardText.delplanitem}
                                    </MenuItem>
                                    <MenuItem onClick={move2dplanitem} key={`handlemoveplanitem`}>
                                      {dashboardText.moveplanitem}
                                    </MenuItem>
                                  </Menu>
                                  {plandisplayiot ? planiotItems.map((item) =>
                                    <Plan2dIot
                                      item={item}
                                      onClick={editionmode ? handleClick2dItemEdit : handleClick2dItem}
                                      iots={iotdata}
                                      avobboxs={avobboxdata}
                                      lorawanboxs={lorawanboxdata}
                                      plan2dfilters={plan2dfilters}
                                      onlynames={onlynames}
                                    />
                                  ) : <></>}
                                  {plandisplayeq ? planeqItems.map((item) =>
                                    <Plan2dEquipment
                                      item={item}
                                      onClick={editionmode ? handleClick2dItemEdit : handleClick2dItem}
                                      equipments={equipmentdata}
                                      points={pointdata}
                                      planrawdata={planrawdata}
                                      plan1ddata={plan1ddata}
                                      plan1hdata={plan1hdata}
                                      datatime={planDatatime}
                                      plan2dfilters={plan2dfilterseq}
                                      onlynames={onlynames}
                                    />
                                  ) : <></>}
                                  {plandisplaydata ? plandataItems.map((item) =>
                                    <Plan2dData
                                      item={item}
                                      onClick={editionmode ? handleClick2dItemEdit : handleClick2dItem}
                                      points={pointdata}
                                      fullpointdata={fullpointdata}
                                      equipmentdata={equipmentdata}
                                      planrawdata={planrawdata}
                                      plan1ddata={plan1ddata}
                                      plan1hdata={plan1hdata}
                                      datatime={planDatatime}
                                      plan2dfilters={plan2dfiltersdata}
                                      onlynames={onlynames}
                                    />
                                  ) : <></>}
                                  {planlinkItems.map((item) =>
                                    <Plan2dLink
                                      item={item}
                                      onClick={editionmode ? handleClick2dItemEdit : handleClick2dItem}
                                      plans={plans2d}
                                    />
                                  )}
                                </PlanImgContainer>

                                {/* <Weatherdiv>
                                      <img
                                        data-src={getServerRootUrl() + "/weather/64x64/day/359.png"}
                                        style={infoWindowImg}
                                        src={getServerRootUrl() + "/weather/64x64/day/359.png"}
                                        data-holder-rendered="true"
                                        alt={""}
                                      />
                                      <WeatherTemp>
                                        {'15,2°c'}
                                      </WeatherTemp>
                                      <WeatherRessTemp>
                                        {'(Ressenti 13,3°c)'}
                                      </WeatherRessTemp>
                                    </Weatherdiv> */}
                                {/* <Plan2dDataTable
                                    plandisplayiot={plandisplayiot}
                                    plandisplayeq={plandisplayeq}
                                    plandisplaydata={plandisplaydata}
                                  >

                                  </Plan2dDataTable> */}
                              </> : <></>
                          }
                        </CardBody>
                      </Card>
                    </GridItem>
                  </GridContainer>
                </GridItem>
              </GridContainer>
            </GridItem></>
          : <></>
      }

      {/* Création/Edition du plan de comptage */}
      <Dialog
        onClose={handleCloseplan}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="md"
        open={openeditmeteringplan}
      >
        <CustomDialogTitle id="addMarket-dialog-title" onClose={handleCloseplan}>
          {currentMeteringplan ? dashboardText.editplan : dashboardText.newplan}
        </CustomDialogTitle>
        <DialogContent dividers>
          {currentMeteringplan ?
            <MeteringPlanDialog
              currentPlan={currentMeteringplan}
              closeModal={handleCloseplan}
              refetch={handleRefreshMeteringPlanList}
              wpgroup={currentWorkspace?.idgroup}
              workspaceid={currentWorkspace.id}
            /> : <MeteringPlanDialog
              closeModal={handleCloseplan}
              refetch={handleRefreshMeteringPlanList}
              wpgroup={currentWorkspace?.idgroup}
              workspaceid={currentWorkspace.id}
            />
          }
        </DialogContent>
        <DialogActions />
      </Dialog>
      {/* Création/Edition des éléments du plan de comptage */}
      <Dialog
        onClose={handleCloseplanitem}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="md"
        open={openplanitem}
      >
        <CustomDialogTitle id="addMarket-dialog-title" onClose={handleCloseplanitem}>
          {currentPlanItem ? dashboardText.editplanitem : dashboardText.newplanitem}
        </CustomDialogTitle>
        <DialogContent dividers>
          {currentPlanItem ?
            <MeteringPlanItemDialog
              currentItem={currentPlanItem}
              meteringPlan={meteringplandetails}
              closeModal={handleCloseplanitem}
              refetch={handleRefreshMeteringPlan}
              points={pointdata}
              tree={tree}
              groups={wpgrouplist}
            /> : <MeteringPlanItemDialog
              meteringPlan={meteringplandetails}
              closeModal={handleCloseplanitem}
              refetch={handleRefreshMeteringPlan}
              points={pointdata}
              tree={tree}
              groups={wpgrouplist}
            />
          }
        </DialogContent>
        <DialogActions />
      </Dialog>
      {/* Dialogue pour les données d'un élément */}
      <Dialog
        onClose={handleCloseplanitemdata}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="lg"
        open={openplanitemdata}
      >
        <CustomDialogTitle id="addMarket-dialog-title" onClose={handleCloseplanitemdata}>
          {dashboardText.dataof + currentDataItem?.parameters?.name}
        </CustomDialogTitle>
        <DialogContent dividers>
          <ViewPointDataDialog
            currentItem={currentDataItem}
            tree={tree}
            meteringPlan={meteringplandetails}
            closeModal={handleCloseplanitemdata}
            pointdata={pointdata}
            planrawdata={planrawdata}
            plan1ddata={plan1ddata}
            plan1hdata={plan1hdata}
          />
        </DialogContent>
        <DialogActions />
      </Dialog>
      {/* Dialogue pour le diagramme de sankey */}
      <Dialog
        onClose={handleClosesankey}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="lg"
        open={opensankey}
      >
        <CustomDialogTitle id="addMarket-dialog-title" onClose={handleClosesankey}>
          {dashboardText.sankeydialog}
        </CustomDialogTitle>
        <DialogContent dividers>
          <SankeyDialog
            currentItem={selectedTreeItem}
            tree={tree}
            closeModal={handleClosesankey}
            pointdata={pointdata}
          />
        </DialogContent>
        <DialogActions />
      </Dialog>
      {/* Création/Edition d'un plan 2D */}
      <Dialog
        onClose={handleClose2dplan}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="md"
        open={openedit2dplan}
      >
        <CustomDialogTitle id="addMarket-dialog-title" onClose={handleClose2dplan}>
          {current2dplan ? dashboardText.edit2dplan : dashboardText.new2dplan}
        </CustomDialogTitle>
        <DialogContent dividers>
          {current2dplan ?
            <Plan2dDialog
              currentPlan={current2dplan}
              closeModal={handleClose2dplan}
              refetch={handleRefresh2dPlanList}
              wpgroup={currentWorkspace?.idgroup}
              workspaceid={currentWorkspace.id}
            /> : <Plan2dDialog
              closeModal={handleClose2dplan}
              refetch={handleRefresh2dPlanList}
              wpgroup={currentWorkspace?.idgroup}
              workspaceid={currentWorkspace.id}
            />
          }
        </DialogContent>
        <DialogActions />
      </Dialog>
      {/* Création/Edition des éléments du plan 2D */}
      <Dialog
        onClose={handleClose2dplanitem}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="md"
        open={open2dplanitem}
      >
        <CustomDialogTitle id="addMarket-dialog-title" onClose={handleClose2dplanitem}>
          {current2dPlanItem ? dashboardText.editplanitem : dashboardText.newplanitem}
        </CustomDialogTitle>
        <DialogContent dividers>
          {current2dPlanItem ?
            <Plan2dItemDialog
              currentItem={current2dPlanItem}
              closeModal={handleClose2dplanitem}
              refetch={handleRefresh2dPlanList}
              fullpoints={fullpointdata}
              points={pointdata}
              iots={iotdata}
              equipments={equipmentdata}
              avobboxs={avobboxdata}
              lorawanboxs={lorawanboxdata}
              groups={wpgrouplist}
              plan={plan2ddetails}
              eventx={currentPositionX}
              eventy={currentPositionY}
              plans={plan2dlist}
            /> : <Plan2dItemDialog
              meteringPlan={meteringplandetails}
              closeModal={handleClose2dplanitem}
              refetch={handleRefresh2dPlanList}
              fullpoints={fullpointdata}
              points={pointdata}
              iots={iotdata}
              equipments={equipmentdata}
              avobboxs={avobboxdata}
              lorawanboxs={lorawanboxdata}
              groups={wpgrouplist}
              plan={plan2ddetails}
              eventx={currentPositionX}
              eventy={currentPositionY}
              plans={plan2dlist}
            />
          }
        </DialogContent>
        <DialogActions />
      </Dialog>
      {/* Visualisation des éléments du plan 2D */}
      <Dialog
        onClose={handleClose2dplanviewiot}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="md"
        open={open2dplanviewiot}
        sx={{ '& .MuiPaper-root': { borderRadius: 5, boxShadow: 3 }, }}
      >
        {/* <CustomDialogTitle id="addMarket-dialog-title" onClose={handleClose2dplanviewiot}>
          {current2dPlanItem.parameters?.name || ""}
        </CustomDialogTitle>
        <DialogContent dividers> */}
        <ViewIotDialog
          currentItem={current2dPlanItem}
          iots={iotdata}
          equipments={equipmentdata}
          plan={plan2ddetails}
          fullpoints={fullpointdata}
          wpgroup={currentWorkspace?.idgroup}
          pointdata={pointdata}
          planrawdata={planrawdata}
          plan1ddata={plan1ddata}
          plan1hdata={plan1hdata}
          workspace={currentWorkspace}
        />
        {/* </DialogContent>
        <DialogActions /> */}
      </Dialog>
      {/* Visualisation des éléments du plan 2D */}
      <Dialog
        onClose={handleClose2dplanviewequipment}
        aria-labelledby="edituser-dialog-title"
        // fullWidth="true"
        maxWidth="false"
        open={open2dplanviewequipment}
        sx={{ '& .MuiPaper-root': { borderRadius: 5, boxShadow: 3 }, }}
      >
        {/* <CustomDialogTitle id="addMarket-dialog-title" onClose={handleClose2dplanviewequipment}>
          {current2dPlanItem.parameters?.name || ""}
        </CustomDialogTitle> */}

        <ViewEquipmentDialog
          currentItem={current2dPlanItem}
          iots={iotdata}
          equipments={equipmentdata}
          plan={plan2ddetails}
          fullpoints={fullpointdata}
          wpgroup={currentWorkspace?.idgroup}
          pointdata={pointdata}
          planrawdata={planrawdata}
          plan1ddata={plan1ddata}
          plan1hdata={plan1hdata}
          refetchfullpoints={refetchfullpoints}
          workspace={currentWorkspace}
        />
        {/* <DialogActions /> */}
      </Dialog>

    </>
  );
};

export default Dashboard;
